import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { handleError } from '../../utils/api-error-handling';

export const channelManagerApi = createApi({
  reducerPath: 'channelManagerApi',
  baseQuery: baseQuery,
  tagTypes: ['ChannelManager'],
  endpoints: (builder) => ({
    buyLicense: builder.mutation({
      query: () => ({
        url: 'integrations/channelmanagers/licenses',
        method: 'POST',
      }),
      invalidatesTags: ['ChannelManager'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    createProperty: builder.mutation({
      query: () => ({
        url: 'integrations/channelmanagers/property',
        method: 'POST',
      }),
      invalidatesTags: ['ChannelManager'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    fullSync: builder.mutation({
      query: () => ({
        url: 'integrations/channelmanagers/full-sync',
        method: 'POST',
      }),
      invalidatesTags: ['ChannelManager'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const {
  useBuyLicenseMutation,
  useCreatePropertyMutation,
  useFullSyncMutation,
} = channelManagerApi;
